import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class BlockCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.Block;
    }
    visitNode(sb, expr, options) {
        sb.emitHelper(expr, options, sb.helpers.processStatements({ createScope: true }));
    }
}

//# sourceMappingURL=BlockCompiler.js.map
